import _asyncToGenerator from "F:/vue2.0+ vant/2024\u5E74\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u5B98\u7F51\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u4E2D\u6587\u7248\u672C/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import MiniPagination from "@/components/MiniPagination/index.vue"; // import Baidumap from "@/pages/contactUs/components/baidumap.vue"

import { onMounted, onBeforeUnmount, ref, reactive, watch, defineComponent } from "vue";
import { getJobsList_url, getContactUsInfo_url } from "@/api"; //引入发送请求获取数据的方法

import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue.js";
import SwiperCore, { Navigation, Pagination, EffectFade } from "swiper";
import "swiper/swiper.min.css";
import "swiper/modules/effect-fade/effect-fade.min.css"; //引入轮播样式-

import "swiper/modules/pagination/pagination.min.css";
export default defineComponent({
  props: {
    num: {
      type: Number,
      default: 4
    }
  },
  components: {
    MiniPagination: MiniPagination,
    Swiper: Swiper,
    SwiperSlide: SwiperSlide // Baidumap,

  },
  name: "Media",
  setup: function setup(props) {
    var swiperInstance = ref(null); // swiper配置项

    function onSwiper(swiper) {
      swiperInstance.value = swiper;
    }

    var selectIndex = ref(0);

    var jobSelect = function jobSelect(index) {
      selectIndex.value = index;
    };

    var slide = ref(0);
    var swiper_option = reactive({
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      fadeEffect: {
        crossFade: false
      },
      loop: false,
      speed: 1000,
      showNum: props.num // on: {
      //   slideChangeTransitionEnd: handleSlideChange,
      // },

    });
    onMounted(function () {
      // getJobsList()
      getContactUsInfo();
    });

    var currentPage = function currentPage(val) {
      var Swiper = swiperInstance.value; // console.log(Swiper,'获取成功了吗');

      var pageNum = val;
      Swiper.slideTo(pageNum * props.num - 1, 1000, false); // Swiper.slideNext()
    };

    var jboList = ref([{
      title: "销售渠道",
      palce: "南昌",
      number: 5,
      education: "本科",
      time: "2017/09/28",
      id: 1
    }, {
      title: "国际贸易采购专员",
      palce: "南昌",
      number: 5,
      education: "本科",
      time: "2017/09/28",
      id: 2
    }, {
      title: "采购工程师",
      palce: "南昌",
      number: 5,
      education: "本科",
      time: "2017/09/28",
      id: 3
    }, {
      title: "国际贸易采购专员",
      palce: "南昌",
      number: 5,
      education: "本科",
      time: "2017/09/28",
      id: 4
    }, {
      title: "销售渠道",
      palce: "南昌",
      number: 5,
      education: "本科",
      time: "2017/09/28",
      id: 5
    }, {
      title: "采购工程师",
      palce: "南昌",
      number: 5,
      education: "本科",
      time: "2017/09/28",
      id: 6
    }]);
    var contactUsInfo = ref({});

    var getJobsList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  currentPage: 1,
                  pageSize: 999,
                  title: ''
                };
                _context.next = 3;
                return getJobsList_url(params);

              case 3:
                res = _context.sent;

                // console.log(res,'这是职位列表');
                if (res.code == 200) {
                  jboList.value = res.data.jobsList;
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getJobsList() {
        return _ref.apply(this, arguments);
      };
    }();

    var getContactUsInfo = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getContactUsInfo_url();

              case 2:
                res = _context2.sent;
                //  console.log(res,'这是联系我们信息');
                contactUsInfo.value = res.data.contactUsInfo;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getContactUsInfo() {
        return _ref2.apply(this, arguments);
      };
    }(); // ------------------------------------------------------------------------------------------------------------------------//


    var messageForm = reactive({
      name: "",
      phone: "",
      email: ""
    });
    var rules = reactive({
      name: [{
        required: true,
        message: "请输入姓名",
        trigger: "blur"
      }],
      phone: [{
        required: true,
        message: "请输入您的手机号",
        trigger: "blur"
      }, {
        pattern: /^1[3456789]\d{9}$/,
        message: "请输入正确格式的手机号"
      }],
      email: [{
        required: true,
        message: "请输入您的邮箱",
        trigger: "blur"
      }]
    });
    var upLoadBtn = ref(null);

    var upNotesClk = function upNotesClk() {
      upLoadBtn.value.$el.click(); // console.log(upLoadBtn)
    };

    var handleChange = function handleChange(file, fileList) {// console.log(file, fileList, "这是获取的文件列表")
    };

    var center = reactive({
      lng: 0,
      lat: 0
    }); //经纬度

    var zoom = ref(1); //地图展示级别

    return {
      selectIndex: selectIndex,
      jobSelect: jobSelect,
      onSwiper: onSwiper,
      swiperInstance: swiperInstance,
      currentPage: currentPage,
      jboList: jboList,
      swiper_option: swiper_option,
      messageForm: messageForm,
      rules: rules,
      upLoadBtn: upLoadBtn,
      upNotesClk: upNotesClk,
      handleChange: handleChange,
      center: center,
      zoom: zoom,
      contactUsInfo: contactUsInfo
    };
  }
});